export default () => ({
  play() {
    this.$refs.player.showPopover()
    this.$refs.player.play()
  },
})
